var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-button-box",class:_vm.className},[_c('button',{staticClass:"audio-button",class:{'on': _vm.audioPlay, 'off': !_vm.audioPlay},attrs:{"type":"default"},on:{"click":_vm.toggleAudio}})])}
var staticRenderFns = []

export { render, staticRenderFns }